import { render, staticRenderFns } from "./DerekOwnRiskDiscountModal.vue?vue&type=template&id=66e19e32"
import script from "./DerekOwnRiskDiscountModal.vue?vue&type=script&lang=js"
export * from "./DerekOwnRiskDiscountModal.vue?vue&type=script&lang=js"
import style0 from "./DerekOwnRiskDiscountModal.vue?vue&type=style&index=0&id=66e19e32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports